/**
 * 简单查询框, 可以在简单模式与高级模式间切换,
 * 当然如果不加children属性的话自动只显示简单模式
 * # 注意, 该组件自动与form配合, 不需要form.item包裹
 */
import React, {useState} from 'react';
import {Button, Form, Input, Row, Space} from 'antd';
import styles from './index.module.scss';
import {FormItemProps} from 'antd/lib/form/FormItem';
import FormFilter from '../FormFilter';

interface FormSearchProps<T> extends FormItemProps<T> {
    name: any; // 查询框的name属性
    placeholder?: string; // 文本框提示
    maxLength?: number; // 最大长度
    children?: React.ReactNode;
    noMargin?: boolean; // 不显示底边距
    onExpandChange?: (expand: boolean) => void;
}

export default function FormSearch<T>({
    name,
    placeholder,
    maxLength,
    children,
    noMargin,
    onExpandChange,
    preserve = true,
    ...formProps
}: FormSearchProps<T>) {
    const [expand, setExpand] = useState(false);

    function handleExpandChange(expand: boolean) {
        setExpand(expand);
        onExpandChange?.(expand);
    }

    const advancedItems = React.Children.toArray(children).filter(
        (item: any) => item?.type !== FormFilter,
    );

    const filterItems = React.Children.toArray(children).filter(
        (item: any) => item?.type === FormFilter,
    );

    return (
        <>
            <div
                className={styles.root}
                style={{marginBottom: noMargin ? 0 : 10}}>
                {!expand && (
                    <div className={styles.simpleForm}>
                        <Form.Item name={name} noStyle {...formProps} preserve>
                            <Input
                                className={styles.simpleInput}
                                placeholder={placeholder}
                                maxLength={maxLength}
                                allowClear
                            />
                        </Form.Item>

                        <Button
                            htmlType="submit"
                            type="primary"
                            className={styles.simpleButton}>
                            搜索
                        </Button>

                        {children && (
                            <Button
                                className={styles.link}
                                type="link"
                                onClick={() => handleExpandChange(true)}>
                                【 高级搜索 】
                            </Button>
                        )}
                    </div>
                )}

                {expand && (
                    <div>
                        <Row>{advancedItems}</Row>

                        <div className={styles.bottom}>
                            <Space>
                                <Button type="primary" htmlType="submit">
                                    搜索
                                </Button>

                                <Button type="default" htmlType="reset">
                                    重置
                                </Button>

                                <Button
                                    className={styles.link}
                                    type="link"
                                    onClick={() => handleExpandChange(false)}>
                                    【 关闭高级搜索 】
                                </Button>
                            </Space>
                        </div>
                    </div>
                )}
            </div>

            {!expand && filterItems}
        </>
    );
}

FormSearch.defaultProps = {
    placeholder: '请输入',
    noMargin: false,
    preserve: false,
};
